package com.iregained.site.components.sections.news.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

val NewsFeaturedContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White)
}

val FeaturedCardWrapperStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().maxWidth(1200.px).backgroundColor(Colors.White).borderRadius(24.px)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .boxShadow(0.px, 20.px, 50.px, color = Colors.Black.copy(alpha = 5)).overflow(Overflow.Hidden)
            .transition(Transition.of("box-shadow", 300.ms), Transition.of("transform", 300.ms))
    }
    hover {
        Modifier.transform { translateY((-4).px) }.boxShadow(0.px, 30.px, 60.px, color = Colors.Black.copy(alpha = 10))
    }
}

val FeaturedCardGridStyle = CssStyle.base {
    Modifier.fillMaxWidth()
}

val FeaturedImageWrapperStyle = CssStyle.base {
    Modifier.fillMaxWidth().height(100.percent).minHeight(300.px)
}

val FeaturedImageStyle = CssStyle.base {
    Modifier.fillMaxSize().objectFit(ObjectFit.Cover)
}

val FeaturedContentColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(48.px).display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
        // FIXED: Fully qualified JustifyContent to resolve ambiguity
        .justifyContent(JustifyContent.Center)
}

val FeaturedTagStyle = CssStyle.base {
    Modifier.color(Colors.White).backgroundColor(colorMode.toSitePalette().brand.primary) // Brand Teal
        .padding(topBottom = 6.px, leftRight = 16.px).borderRadius(50.px).fontSize(0.85.cssRem)
        .fontWeight(FontWeight.Bold).textTransform(TextTransform.Uppercase).letterSpacing(1.px).width(Width.FitContent)
        .margin(bottom = 24.px)
}

val FeaturedHeadlineStyle = CssStyle.base {
    Modifier
        // FIXED: Swapped unresolved custom palette for a safe dark color
        .color(Colors.DarkSlateGray).fontSize(2.5.cssRem).fontWeight(FontWeight.Bold).lineHeight(1.2)
        .margin(bottom = 16.px)
}

val FeaturedSummaryStyle = CssStyle.base {
    Modifier
        // FIXED: Swapped unresolved 'lightText' for a safe Gray
        .color(Colors.Gray).fontSize(1.125.cssRem).lineHeight(1.6).margin(bottom = 32.px)
}

val FeaturedMetaRowStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex)
        // FIXED: Fully qualified AlignItems and JustifyContent
        .alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
        // FIXED: Replaced unresolved 'auto' with a fixed top margin to push it down
        .margin(top = 32.px)
}

val FeaturedDateStyle = CssStyle.base {
    Modifier
        // FIXED: Swapped unresolved 'lightText' for a safe Gray
        .color(Colors.Gray).fontSize(0.95.cssRem).fontWeight(FontWeight.Medium)
}

val FeaturedLinkStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(1.05.cssRem).fontWeight(FontWeight.Bold)
        .textDecorationLine(TextDecorationLine.None).display(DisplayStyle.Flex)
        // FIXED: Fully qualified AlignItems
        .alignItems(AlignItems.Center).gap(8.px)
}